import React from 'react'
import { BtnRightArrow } from '../constants/svgPath'
import imagePath from '../constants/imagePath';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";

const checkSliderData = [
  {
    img: imagePath.RChechImg1,
    date: "August 24, 2025",
    title: "Top 10 Emerging Tech Trends Transforming Businesses in 2025."
  },
  {
    img: imagePath.RChechImg2,
    date: "August 24, 2025",
    title: "How AI and Automation Are Reshaping Modern Enterprises."
  },
  {
    img: imagePath.RChechImg3,
    date: "August 24, 2025",
    title: "How to Choose the Right IT Partner for Your Business."
  },
  {
    img: imagePath.RChechImg1,
    date: "August 24, 2025",
    title: "Top 10 Emerging Tech Trends Transforming Businesses in 2025."
  },
  {
    img: imagePath.RChechImg2,
    date: "August 24, 2025",
    title: "How AI and Automation Are Reshaping Modern Enterprises."
  },
  {
    img: imagePath.RChechImg3,
    date: "August 24, 2025",
    title: "How to Choose the Right IT Partner for Your Business."
  }
];
function LatestNews() {
  return (
    <section className="check_sec">
        <div className="contair ">
          <div className="heading">
            <h2>Check Our Latest News and Updates</h2>
          </div>
          <div className="check_inr">
            <Swiper
              cssMode={true}
       navigation={{
          enabled: true,
        }}
              pagination={false}
              keyboard={true}
              slidesPerView={3}
              // centeredSlides={true}
              spaceBetween={24}
              breakpoints={{
                 320: {
                navigation: { enabled: false },
                slidesPerView: 1.2, // 👈 thoda next slide dikhega
                centeredSlides: true,
                spaceBetween: 16,
              },

              767: {
                navigation: { enabled: true },
                slidesPerView: 2,
                spaceBetween: 20,

              },
                1024: {
                  slidesPerView: 3,
                  centeredSlides: false,
                },
              }}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="swiper_sldr"
            >
              {checkSliderData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="check_slider">
                    <figure className="check_img">
                      <img src={item.img} alt={item.title} />
                    </figure>
                    <p>{item.date}</p>
                    <h3>{item.title}</h3>
                    <div className="check_btn">
                        <button type="button" className="btn_common btn_primry">Read More<span><BtnRightArrow /></span></button>
                    </div>
                    
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>



          </div>
        </div>
      </section>
  )
}

export default LatestNews